module.exports = "fonts/Twemoji_Mozilla/TwemojiMozilla-sbix.661486d.woff2";